import OnlyHeader from "components/Layout/OnlyHeader";
import React, { useCallback, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardText,
  CardTitle,
  Col,
  Container,
  Input,
  Row,
  Spinner,
} from "reactstrap";
import { getTutorials } from "store/actions/tutorialsActions";
import { useDispatch, useSelector } from "react-redux";

const Tutorials = () => {
  const dispatch = useDispatch();
  const { loading, tutorials } = useSelector((state) => state.tutorials);

  const [searchTerm, setSearchTerm] = useState("");
  const [tutorialsData, setTutorialsData] = useState(tutorials);
  const [entries, setEntries] = useState("");

  const handleChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const searchTutorials = useCallback(
    (searchTerm) => {
      const lowerCaseSearch = searchTerm.toLowerCase().trim();

      return tutorials.filter((tutorial) => {
        const { title = "" } = tutorial;
        return title.toLowerCase().includes(lowerCaseSearch);
      });
    },
    [tutorials]
  );

  useEffect(() => {
    if (searchTerm.trim()) {
      const filteredTutorials = searchTutorials(searchTerm);
      setTutorialsData(filteredTutorials);
    } else {
      setTutorialsData(tutorials);
    }
  }, [searchTerm, searchTutorials, tutorials]);

  useEffect(() => {
    dispatch(getTutorials(entries));
  }, [dispatch, entries]);

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center px-2 px-lg-4">
                <Col xs="12" md="3" className="mb-3 mb-lg-0">
                  <h3 className="mb-0">Tutorials</h3>
                </Col>
                <Row className="w-100 mx-0 d-flex justify-content-end">
                  <Col xs="12" md="4" className="mb-3 mb-sm-0">
                    <Input
                      placeholder="Search by title"
                      value={searchTerm}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col xs="12" md="4">
                    <Input
                      name="entries"
                      type="select"
                      value={entries}
                      onChange={(e) => setEntries(e.target.value)}
                    >
                      <option value="">All Entries</option>
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                    </Input>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody>
                {loading ? (
                  <div className="d-flex justify-content-center align-items-center py-5">
                    <Spinner color="primary" />
                  </div>
                ) : tutorialsData?.length > 0 ? (
                  <Row className="p-0 p-lg-3">
                    {tutorialsData?.map((tutorial, index) => (
                      <Col
                        key={index}
                        xl={4}
                        lg={4}
                        md={6}
                        sm={6}
                        xs={12}
                        className="mb-4"
                      >
                        <Card className="w-100 h-100 shadow-sm overflow-hidden border border-gray">
                          <CardHeader
                            className="w-100 p-0"
                            style={{ height: "175px" }}
                          >
                            <video
                              controls
                              muted
                              className="w-100 h-100"
                              style={{ objectFit: "cover" }}
                            >
                              <source src={tutorial?.video} type="video/mp4" />
                            </video>
                          </CardHeader>
                          <CardBody>
                            <CardTitle tag="h3" className="p-0 mb-2">
                              {tutorial?.title}
                            </CardTitle>
                            <CardText style={{ fontSize: 14 }}>
                              {tutorial?.text}
                            </CardText>
                          </CardBody>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                ) : (
                  <div className="d-flex flex-column justify-content-center align-items-center py-5">
                    No Tutorial Found
                  </div>
                )}
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Tutorials;
